import TemplateLayout from '@/components/layouts/TemplateLayout';
import Loader from '@/components/molecules/loader';
import theme from '@/styles/theme';

const TelemedicineRequestLoader = () => {
  return (
    <TemplateLayout.Wrapper>
      <TemplateLayout.Content>
        <div className='flex h-[100vh] items-center justify-center'>
          <Loader color={theme.color.gray600} />
        </div>
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};

export default TelemedicineRequestLoader;
